<template>
  <v-skeleton-loader class="mx-auto" :height="height" :type="type" loading />
</template>

<script>
export default {
  name: 'AppSkeleton',

  props: {
    type: {
      required: true,
      type: String
    },

    height: {
      type: String
    },

    width: {
      type: String
    }
  }
}
</script>
